import React, { ReactElement ,useState, useContext} from 'react';
import { useNavigate } from 'react-router-dom';
import { SubmittedFlag } from '../../components/common/StatusContext';
import { useCookies } from 'react-cookie';
import { CookieSetOptions } from 'universal-cookie'

/**
 * ヘッダーコンポーネント
 * @returns ReactElement<void>
 */
export function Header(): ReactElement<void> {
  const navigate = useNavigate();
  
  //    未申込/申込済みタブの切替を保持するコンテキスト
  const submittedFlag = useContext(SubmittedFlag);

  //    ハンバーガーメニューの切替を保持するstate
  const [humStatus, setHumStatus] = useState(false);
  let humbergerBoxClassName = "hd-adminhamburger-box";
  if(humStatus){
    humbergerBoxClassName += " is-open";
  }

  //  Cookieの有効期限:　7日間
  const _7_DayBySeconds = 60 * 60 * 24 * 7;

  //    アカウントIDを保存するCookie
  const [cookieAccId, setCookieAccId, removeCookieAccId] = useCookies(['idCookie']);
  const accIdOptions: CookieSetOptions = {
    path: '/',
    maxAge: _7_DayBySeconds
}

  //  対応会員番号を保存するcookie（秘書の場合のみ）
  const [cookieSecAccId, setCookieSecAccId, removeCookieSecAccId] = useCookies(['secIdCookie'])
  const secAccIdOptions: CookieSetOptions = {
      path: '/',
      maxAge: _7_DayBySeconds
  }

  //  メールアドレスを保存するcookie
  const [cookieMail, setCookieMail, removeCookieMail] = useCookies(['mailCookie']);
  const mailOptions: CookieSetOptions = {
      path: '/',
      maxAge: _7_DayBySeconds
  }

  //  パスワードを保存するcookie
  const [cookiePass, setCookiePass, removeCookiePass] = useCookies(['passCookie'])
  const passOptions: CookieSetOptions = {
      path: '/login',
      maxAge: _7_DayBySeconds
  }

  //  ロータリーCDを保存するcookie
  const [cookieRotaryCd, setCookieRotaryCd, removeCookieRotaryCd] = useCookies(['rotaryCookie'])
  const rotaryCdOptions: CookieSetOptions = {
      path: '/',
      maxAge: _7_DayBySeconds
  }

  const removeAllCookie = () => {
    removeCookieAccId('idCookie', accIdOptions);
    removeCookieSecAccId('secIdCookie', secAccIdOptions)
    removeCookieMail('mailCookie', mailOptions);
    removeCookiePass('passCookie', passOptions);
    removeCookieRotaryCd('rotaryCookie', rotaryCdOptions);
  }

  
  return (
    <header className="l-header">
      <div className="l-inner">
        <div className="hd-wrap">
          <div className="logo">
            <a href="/mypage">
              <span className="img">
                <img src={`${process.env.PUBLIC_URL}/img/logo.png`} alt="" />
              </span>
              <span className="txt">例会参加者管理システム</span>
            </a>
          </div>
          <div className={humbergerBoxClassName}>
            <button 
              className="hd-adminhamburger-btn js-adminhamburger"
              onClick={() => {setHumStatus(!humStatus)}}
            >
              <i className="line"></i>
            </button>
            <nav className="hd-adminhamburger-nav">
										<ul>
											<li>
                      <a onClick={() =>{
                          setHumStatus(false)
                          submittedFlag.changeSubmitted(false)
                          navigate("/mypage")
                        }}>申込できるイベント</a>
                      </li>
											<li>
                        <a onClick={() =>{
                          setHumStatus(false)
                          submittedFlag.changeSubmitted(true)
                          navigate("/mypage")
                        }}>申込済みのイベント</a>
                      </li>
											<li>
                        <a href="/past-event">過去に申し込んだイベント</a>
                      </li>
											<li>
                        <a href="/makeup">メークアップ登録</a>
                      </li>
										</ul>
										<div className="submenu">
											<a className="hd-logout" 
                        onClick={() => {
                          removeAllCookie()
                          navigate("/login");
                        }}>
                          ログアウト</a>
										</div>
									</nav>
          </div>
        </div>
      </div>
    </header>
  );
}
